import { Input, Modal } from 'semantic-ui-react';
import { Footer } from './Footer';
import { DebouncedLoader, ErrorsContextProvider, ValidationErrors } from 'components';
import { useAddRoomToSpeakingSession } from './useAddRoomToSpeakingSession';
import styled from '@emotion/styled';
import { AvailableRoomsTable } from './AvailableRoomsTable';

export const AddRoomToSpeakingSession = () => {
  const {
    speakingSessionId,
    availableRooms,
    isLoading,
    addRoomsToSession,
    isAddingRooms,
    addedRooms,
    errors,
    selectedRooms,
    setSelectedRooms,
    searchTerm,
    setSearchTerm,
  } = useAddRoomToSpeakingSession();

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open data-testid="add-rooms-modal-speaking">
        <S.ModalHeader>
          <div>Add room(s)</div>{' '}
          <S.InputWrapper>
            <S.SearchInput
              icon="search"
              iconPosition="left"
              size="mini"
              onChange={(_e, v) => setSearchTerm(v.value)}
            />
          </S.InputWrapper>
        </S.ModalHeader>
        <Modal.Content>
          <S.ValidationErrors />
          <S.TableContainer>
            {!availableRooms || isLoading ? (   
              <DebouncedLoader margin="10rem 0" />
            ) : (
              <AvailableRoomsTable
                availableRooms={availableRooms}
                onSelectedRoomsChanged={setSelectedRooms}
                searchTerm={searchTerm}
              />
            )}
          </S.TableContainer>
        </Modal.Content>
        <Footer
          saved={addedRooms}
          isSaving={isAddingRooms}
          disabled={!selectedRooms.length}
          sessionId={speakingSessionId}
          onConfirm={() => addRoomsToSession({
            speakingSessionId,
            request: {
              rooms: selectedRooms,
            },
          })}
        />
      </Modal>
    </ErrorsContextProvider>
  );
};

const S = {
  TableContainer: styled.div`
    margin: calc(-1.5rem - 1px) calc(-1.5rem + 1px);
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
  `,
  ValidationErrors: styled(ValidationErrors)`
    &.ui.error.message {
      margin-bottom: 3rem;
    }
  `,
  Centered: styled.div`
    display: flex;
    justify-content: center;
  `,
  ModalHeader: styled(Modal.Header)`
    width: 100%;
    display: flex !important;
    flex-direction: row;
  `,
  SearchInput: styled(Input)`
    border: none;
    &.ui.input > input {
      border-radius: 100px;
    }
  `,
  InputWrapper: styled.div`
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};
